import HDR from 'constants/httpHeader.const';
import MIME from 'constants/mime.const';
import fromAnyToErrorMessage from 'utils/converters/any/fromAnyToErrorMessage.util';
import isMissing from 'utils/predicates/any/isMissing.util';

// NOTE: 418 is in the specification even if generally unused and added as a silly joke - it's used now, for mocks
const ERROR_STATUS = 418;
const ERROR_STATUS_TEXT = 'Mocking error';

const mockJsonResponse = (options) => {
  try {
    const body = isMissing(options?.body) ? null : JSON.stringify(options?.body);

    const init = {
      status: options?.status,
      statusText: options?.statusText,
      headers: !options?.headers && body ? { [HDR.ct]: MIME.json } : options?.headers,
    };

    // SEE: https://developer.mozilla.org/en-US/docs/Web/API/Response/Response
    return new Response(body, init);
  } catch (e) {
    return new Response(fromAnyToErrorMessage(e), { status: ERROR_STATUS, statusText: ERROR_STATUS_TEXT });
  }
};

export default mockJsonResponse;
